
import BuildInfo from '../helper/BuildInfo';
class Crime {
    uuid: string;
    dateInspection: string;
    objectId: string;
    objectName: string;
    crimeDescription: string;
    categoryId: string;
    sendToUnitId: string;
    isProductionSafety: boolean;
    appBuild: number;
    versionName: string;
    constructor() {
        let uuidv1 = require('uuid/v1');

        let date = new Date();
        let year = date.getFullYear();
        let day = date.getDate();
        let month = date.getMonth() + 1;

        this.uuid = uuidv1();
        this.dateInspection = day + '.' + month + '.' + year;
        this.objectId = '';
        this.objectName = '';
        this.crimeDescription = '';
        this.categoryId = '';
        this.sendToUnitId = '';
        this.isProductionSafety = false;
        this.appBuild = BuildInfo.build;   // deprecated
        this.versionName = BuildInfo.versionName;
    };

    toURLFormat(user_id: string): string {
        if (this.objectId !== '') {
            this.objectName = "";
        }
        return "uploadFormat=URL"
            + "&userId=" + user_id
            + "&uuid=" + this.uuid
            + "&dateInspection=" + this.dateInspection
            + "&categoryId=" + this.categoryId
            + "&crimeDescription=" + this.crimeDescription
            + "&sendToUnitId=" + this.sendToUnitId
            + "&appBuild=" + this.appBuild // deprecated
            + "&versionName=" + this.versionName
            + "&objectId=" + this.objectId
            + "&objectName=" + this.objectName
            + "&";
    }

    toBase64(userId: string): string {
        return (
            btoa( //base64
                unescape(
                    encodeURIComponent(
                        this.toURLFormat(userId)
                    )
                )
            )
        )
    }
}

// Crime.propTypes = {
//     uuid: PropTypes.string.isRequired,
//     dateInspection: PropTypes.string.isRequired,
//     objectId: PropTypes.string.isRequired,
//     objectName: PropTypes.string.isRequired,
//     crimeDescription: PropTypes.string.isRequired,
//     categoryId: PropTypes.string.isRequired,
//     sendToUnitId: PropTypes.string.isRequired,
//     isProductionSafety: PropTypes.bool.isRequired,
// };

export default Crime;